import { computed } from 'vue';

export function usePasswordValidation(password) {
    const validations = computed(() => {
        const pwd = typeof password === 'function' ? password() : password?.value || password || '';

        return {
            hasMinLength: pwd.length >= 8,
            hasUppercase: /[A-Z]/.test(pwd),
            hasLowercase: /[a-z]/.test(pwd),
            hasNumber: /[0-9]/.test(pwd),
            hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
        };
    });

    const isValid = computed(() => {
        return validations.value.hasMinLength &&
            validations.value.hasUppercase &&
            validations.value.hasLowercase &&
            validations.value.hasNumber &&
            validations.value.hasSpecialChar;
    });

    return {
        validations,
        isValid
    };
}
